import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormCheck, FormInput } from "go-form";
import { EmployeeApi } from "../../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<EmployeeApi>;
}

const EmployeeTipsForm = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		watch,
		register,
		formState: { errors },
	} = form;

	const handleFormatIBANInputValue = (value: string) => {
		return value
			.replace(/^([A-Za-z]{2}\d{2}|\d{2})(?=\d)/, "$1 ")
			.replace(/(\d{4})(?=\d)/g, "$1 ")
			.trim()
			.toLocaleUpperCase();
	};

	return (
		<fieldset className="form-group">
			<div className="d-flex align-items-center flex-wrap gap-2 mb-3">
				<h5 className="mb-0">{t("modules.employee.field.tips.title")}</h5>
				<span className={`badge ${watch("accept_tips") ? "bg-success" : "bg-danger"}`}>
					{watch("accept_tips")
						? t("modules.employee.field.tips_enabled.title")
						: t("modules.employee.field.tips_disabled.title")}
				</span>
			</div>
			<FormCheck
				type="switch"
				label={t("modules.employee.field.accept_tips.title")}
				register={register}
				name="accept_tips"
				help={t("modules.employee.field.accept_tips.help_text")}
				errors={errors}
			/>
			<FormInput
				name="bank_account_number"
				errors={errors}
				register={register}
				label={t("modules.employee.field.bank_account_number.title")}
				maxLength={34}
				disabled={!watch("accept_tips")}
				onChange={(event) => {
					event.target.value = handleFormatIBANInputValue(event.target.value);
				}}
			/>
		</fieldset>
	);
};

export default EmployeeTipsForm;
